import React from "react";
import Card from "../UI/Card";

const EmailBox = (props) => {
  return (
    <div className="container" style={{ marginTop: "30px" }}>
      <a
      /*   href="mailto:rashidrizvi998@gmail.com" */
      /*  onClick={(e) => {
          e.preventDefault();
          window.open("mailto:rashidrizvi998@gmail.com", "_self");
        }} */
      >
        <Card className="m-auto contactCard">
          <p className="text-center font-12 primaryColor ptb">Contact me via</p>
          <p className="text-center font-25 textColor ptb scaleIn">
            rashidrizvi998@gmail.com
          </p>
        </Card>
      </a>
    </div>
  );
};

export default EmailBox;
